<template>
    <div class="sub_Navi alarm">
        <ul class="alarm">
            <li><a class="back" @click="goBack">뒤로</a></li>
            <li>
                <h1>{{ title }}</h1>
            </li>
            <li class="alarm_header_guide">
                <img src="@/assets/images/dark/icon_question.svg" @click="toggleGuide"/>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { defineEmits, computed, defineProps, ref, watch } from 'vue'

const route = useRoute();
const router = useRouter();
const emit = defineEmits(['back']);
const subPath = ref(route.path.split('/')[2])
const type = ref(route.query.type)

const props = defineProps({
   title: String,
});

const title = computed(() => props.title);

function toggleGuide() {
    router.push(`/alarm/guide?subPath=${subPath.value}&type=${type.value}`)
}

function goBack() {
    if (subPath.value == 'light-detail') {
        router.push('/alarm/light')
        return
    }

    emit('back');
}

watch(route, (newRoute) => {
  subPath.value = newRoute.path.split('/')[2];
  type.value = newRoute.query.type;
});
</script>

<style scoped>
.set_alarm_container {
    top: 60px;
    position: fixed;

    width: 100%;
    padding: 0.8rem 1.2rem;
}

.not_sub_category {
    top: 140px;
}

.alarm_header_guide {
    height: 25px;
    display: flex;
}
</style>